// src/js/core/wordListUI.js
import {
  getCurrentLanguage,
  getCurrentLanguageWords,
  updateCurrentLanguageWords,
  clearCurrentLanguageWords,
} from "./wordManager.js";
import { clearTranslations } from "./translateWords.js";

function updateQuizButtonVisibility(wordCount) {
  const quizButton = document.getElementById("quiz-button");
  if (!quizButton) return;

  quizButton.style.display = wordCount >= 4 ? "inline-block" : "none";
}

export function updateUnknownWordsList() {
  const list = document.getElementById("unknown-words-list");
  const clearButton = document.getElementById("clear-words");
  const currentWords = getCurrentLanguageWords();

  // Update quiz button visibility
  updateQuizButtonVisibility(currentWords.size);

  if (currentWords.size === 0) {
    // Hide the clear button when no words exist
    clearButton.style.display = "none";
    // Show the "no saved words" message
    list.innerHTML =
      '<span class="empty-words-message">- Tap on words in a dialogue to save them here.<br>- New dialogues will use your saved words.</span>';
    return;
  }

  // Show the clear button when words exist
  clearButton.style.display = "inline-block";

  // Populate the list with words
  list.innerHTML = Array.from(currentWords)
    .map(
      (word) => `
      <span class="unknown-word-item">
        ${word}
        <button class="remove-word" data-word="${word}" aria-label="Remove ${word}">×</button>
      </span>
    `
    )
    .join("");
}

export function initializeClearButton() {
  document.getElementById("clear-words")?.addEventListener("click", () => {
    if (confirm("Are you sure you want to clear all unknown words for this language?")) {
      clearCurrentLanguageWords();
      clearTranslations(getCurrentLanguage());
      document.querySelectorAll(".word.unknown").forEach((el) => {
        el.classList.remove("unknown");
      });
      updateUnknownWordsList();
    }
  });
}

export function initializeRemoveButtons() {
  document.getElementById("unknown-words-list")?.addEventListener("click", (e) => {
    if (e.target.matches(".remove-word")) {
      const word = e.target.dataset.word;
      const currentWords = getCurrentLanguageWords();
      currentWords.delete(word);
      updateCurrentLanguageWords(currentWords);
      document.querySelectorAll(`.word[data-word="${word}"]`).forEach((el) => {
        el.classList.remove("unknown");
      });
      updateUnknownWordsList();
    }
  });
}
